import { gql } from "@apollo/client";

const MARKETING_WORKSPACE_ASSET_FIELDS = `
  id
  name
  folderId
  altText
  url
  fallbackUrl
  contentType
  width
  height
  sizeBytes
  originalSizeBytes
  createdAt
`;

export const GET_MARKETING_WORKSPACE_ASSETS = gql`
  query GetMarketingWorkspaceAssets(
    $search: String
    $folderId: String
    $includeSubfolders: Boolean
    $pageSize: Int
    $pageNumber: Int
  ) {
    marketingWorkspaceAssets(
      search: $search
      folderId: $folderId
      includeSubfolders: $includeSubfolders
      pageSize: $pageSize
      pageNumber: $pageNumber
    ) {
      items {
        ${MARKETING_WORKSPACE_ASSET_FIELDS}
      }
      count
      pageSize
      pageNumber
    }
  }
`;

export const GET_MARKETING_WORKSPACE_ASSET = gql`
  query GetMarketingWorkspaceAsset($id: String!) {
    marketingWorkspaceAsset(id: $id) {
      ${MARKETING_WORKSPACE_ASSET_FIELDS}
    }
  }
`;

export const UPLOAD_MARKETING_WORKSPACE_ASSET = gql`
  mutation UploadMarketingWorkspaceAsset($file: Upload!, $name: String, $altText: String, $folderId: String) {
    uploadMarketingWorkspaceAsset(file: $file, name: $name, altText: $altText, folderId: $folderId) {
      ${MARKETING_WORKSPACE_ASSET_FIELDS}
    }
  }
`;

export const UPDATE_MARKETING_WORKSPACE_ASSET = gql`
  mutation UpdateMarketingWorkspaceAsset($id: String!, $request: UpdateMarketingWorkspaceAssetInput!) {
    updateMarketingWorkspaceAsset(id: $id, request: $request) {
      ${MARKETING_WORKSPACE_ASSET_FIELDS}
    }
  }
`;

export const DELETE_MARKETING_WORKSPACE_ASSET = gql`
  mutation DeleteMarketingWorkspaceAsset($id: String!) {
    deleteMarketingWorkspaceAsset(id: $id)
  }
`;

export const MOVE_MARKETING_WORKSPACE_ASSETS = gql`
  mutation MoveMarketingWorkspaceAssets($ids: [String!]!, $folderId: String) {
    moveMarketingWorkspaceAssets(ids: $ids, folderId: $folderId)
  }
`;

const MARKETING_WORKSPACE_ASSET_FOLDER_FIELDS = `
  id
  name
  parentId
  assetCount
  createdAt
`;

export const GET_MARKETING_WORKSPACE_ASSET_FOLDERS = gql`
  query GetMarketingWorkspaceAssetFolders {
    marketingWorkspaceAssetFolders {
      ${MARKETING_WORKSPACE_ASSET_FOLDER_FIELDS}
    }
  }
`;

export const CREATE_MARKETING_WORKSPACE_ASSET_FOLDER = gql`
  mutation CreateMarketingWorkspaceAssetFolder($request: CreateMarketingWorkspaceAssetFolderInput!) {
    createMarketingWorkspaceAssetFolder(request: $request) {
      ${MARKETING_WORKSPACE_ASSET_FOLDER_FIELDS}
    }
  }
`;

export const UPDATE_MARKETING_WORKSPACE_ASSET_FOLDER = gql`
  mutation UpdateMarketingWorkspaceAssetFolder($id: String!, $request: UpdateMarketingWorkspaceAssetFolderInput!) {
    updateMarketingWorkspaceAssetFolder(id: $id, request: $request) {
      ${MARKETING_WORKSPACE_ASSET_FOLDER_FIELDS}
    }
  }
`;

export const DELETE_MARKETING_WORKSPACE_ASSET_FOLDER = gql`
  mutation DeleteMarketingWorkspaceAssetFolder($id: String!) {
    deleteMarketingWorkspaceAssetFolder(id: $id)
  }
`;
